// extracted by mini-css-extract-plugin
export default {"title":"CIRtB","content":"acKbD","instagramFeed":"fMRlC"};